import Image from "next/image";

interface InvestmentOverviewProps {
  rows: {
    icon: string;
    price: string;
    title: string;
    subtitle: string;
    listItems: string[];
  }[];
  bgColor: string;
}

const InvestmentOverview = ({ rows, bgColor = "#fffdf6" }: InvestmentOverviewProps) => {
  return (
    <>
      <section
        id="InvestmentOverview-14"
        style={{
          backgroundColor: bgColor
        }}
      >
        <div className="tile-container !pt-0">
          <div className="max-w-[800px]">
            {rows.map((row, index) => (
              <div key={index} className="border-b border-primary-300 py-12">
                <div className="flex flex-row">
                  <div className="flex w-8/12 items-center @2xl:items-start">
                    <Image
                      alt="icon"
                      className="mr-0 h-12 w-12 @2xl:mr-4 @2xl:h-20 @2xl:w-20"
                      width="80"
                      height="80"
                      src={row.icon}
                    />
                    <div className="flex-grow">
                      <p className="mb-3 pl-4 text-lgt font-medium @2xl:text-2xlt">{row.title}</p>
                      <div className="hidden pl-4 text-primary-600 @2xl:block">
                        <p className="pb-4">{row.subtitle}</p>
                        <ul className="list-outside list-disc">
                          {row.listItems?.map((point, i) => (
                            <li className="mb-2 ml-5" key={i}>
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="ml-8 w-4/12 text-right">
                    <p className="block text-xs text-primary-600">Investment</p>
                    <p className="text-sm font-medium leading-4 @2xl:text-xl @2xl:leading-8">{row.price}</p>
                  </div>
                </div>
                <p className="block pt-3 text-sm text-primary-600 @2xl:hidden @2xl:text-base">{row.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default InvestmentOverview;
